import { createAnimation, NavOptions } from '@ionic/core';

interface TransitionOptions extends NavOptions {
  progressCallback?: (ani: Animation | undefined) => void;
  baseEl: any;
  enteringEl: HTMLElement;
  leavingEl: HTMLElement | undefined;
}

function getIonPageElement(element: HTMLElement) {
  if (element.classList.contains('ion-page')) {
    return element;
  }

  const ionPage = element.querySelector(
    ':scope > .ion-page, :scope > ion-nav, :scope > ion-tabs',
  );
  if (ionPage) {
    return ionPage;
  }

  return element;
}

export function pageTransition(_: HTMLElement, opts: TransitionOptions) {
  const DURATION = 300;

  const rootTransition = createAnimation()
    .duration(opts.duration || DURATION)
    .easing('cubic-bezier(.78,.14,.26,.88)'/*'cubic-bezier(0.3,0,0.66,1)'*/);

  const enteringPage = createAnimation()
    .addElement(getIonPageElement(opts.enteringEl))
    .beforeRemoveClass('ion-page-invisible')
    .easing('cubic-bezier(.61,.17,.4,.9)');

  const leavingPage = createAnimation()
    .addElement(getIonPageElement(opts.leavingEl))
    .easing('cubic-bezier(.61,.17,.4,.9)');

  if (opts.direction === 'forward') {
    enteringPage.fromTo('transform', 'translateX(100%)', 'translateX(0)');
    leavingPage.fromTo('transform', 'translateX(0)', 'translateX(-100%)');
    //leavingPage.fromTo('opacity', '1', '0.25');
  } else {
    leavingPage.fromTo('transform', 'translateX(0)', 'translateX(100%)');
    //enteringPage.fromTo('opacity', '0.25', '1');
    enteringPage.fromTo('transform', 'translateX(-100%)', 'translateX(0)');
  }

  rootTransition.addAnimation(enteringPage);
  rootTransition.addAnimation(leavingPage);
  return rootTransition;
}
